import React, { useCallback } from 'react'
import { useNavigate, useParams, NavigateFunction } from 'react-router-dom'

import { t } from '@/i18n'
import { IDriver, IBreadcrumb } from '@/types'
import { AppLayout, Breadcrumbs, LanguageSelector } from '@/components'
import { homePath, makeSearchPath, carsPath } from '@/utils/index'
import { useData } from './useData'
import Form from './form'

const breadcrumbs: IBreadcrumb[] = [
  {
    name: 'search',
    path: homePath,
  },
  {
    name: 'add_driver',
  },
]

const AddDriver: React.FC = () => {
  const navigate: NavigateFunction = useNavigate()
  const { carId = '' } = useParams()
  const { data, loading, submitting, onCancel, onSubmit } = useData({})

  const onSubmitForm = useCallback(
    (d: IDriver) => {
      onSubmit(`cars/${carId}/driver/`, true, () => {
        const viewPath = makeSearchPath(carsPath, {
          id: carId,
          customerId: 'customer',
        })
        navigate(viewPath)
      })({
        driver: d,
      })
    },
    [carId, navigate, onSubmit],
  )

  return (
    <AppLayout
      hasFooter
      headerRight={
        <div className="app-right-container">
          <LanguageSelector />
        </div>
      }
    >
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <div className="page-container">
        <div className="container">
          <div className="page-content">
            <div className="content-box">
              <div className="scroll-wrap">
                <div className="content-title">
                  <h2>{t('add_driver')}</h2>
                </div>
                <Form
                  isEditing
                  loading={loading}
                  submitting={submitting}
                  initialData={data}
                  onCancel={onCancel}
                  onSubmit={onSubmitForm}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  )
}

export default AddDriver
